import http from "./HttpService";

const BASE_SERVICE_URL = "rewards-service";

export default {
  getRewards(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/rewards/customer/all/" + request.page,
          request.param,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getRewardDetails(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          BASE_SERVICE_URL + "/rewards/customer/view/" + request.id,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  redeemReward(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/rewards/customer/redeem`,
          request.param,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  earnPointsViaECode(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/rewards/customer/redeem/instant-grat/points`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  }
};
